import { useEffect, useState } from "react";

/**
 * Returns a copy of `value` that only updates once it has stopped changing for
 * `delayMs`. Used to keep fast-changing input (such as a search box) from
 * firing a request on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debouncedValue;
}
